import React from "react";

import { FaqCategoryItem } from "../../types";
import styles from "../FaqCategoryItems.module.scss";

const Answer = () => (
  <div className={styles.answer}>
    <div className={styles.head}>
      <span className={styles.icon}>A</span>
      <p className={styles.text}>
        教材・授業用動画が表示されない／再生できない場合、通信環境が原因である可能性があります。以下を順にご確認ください。
      </p>
    </div>
    <div>
      <p className={styles.heading}>① 通信環境の確認</p>
      <p className={styles.text}>
        当ヘルプページ下部の[
        <a className={styles.link} href="#environment">
          ご利用環境の確認
        </a>
        ]から、画像が表示されるか／動画が再生できるかを確認してください。
      </p>
    </div>
    <div>
      <p className={styles.heading}>② 確認結果による対応</p>
      <p className={styles.text}>
        【表示・再生できた場合】
        <br />
        通信環境に問題はありません。
        <br />
        教材・授業用動画を再度表示してください。
      </p>
    </div>
    <p className={styles.text}>
      【表示・再生できなかった場合】
      <br />
      通信速度が不足している、またはネットワーク制限がかかっている可能性があります。
      <br />
      学校のネットワーク設定をご確認ください。
    </p>
  </div>
);

export const MATERIAL_VIDEO_UNAVAILABLE_FAQ: FaqCategoryItem = {
  id: "material-video-unavailable-faq",
  question: "教材・授業用動画が表示されない／再生できない",
  Answer,
};
